import { handleActions } from "redux-actions";
import { getRequestObject } from "../../utils/helpers";
import { ACTIONS } from "./actions";

const initialState: CreateSystemState = {
	create: getRequestObject(),
	update: getRequestObject(),
	get: getRequestObject(),
	currentForm: getRequestObject(),
	getFormResult: {
		...getRequestObject(),
		finished: false,
	},
	submitFormResult: getRequestObject(),
};

export default handleActions(
	{
		[`${ACTIONS.CREATE}_PENDING`]: (state) => ({
			...state,
			create: {
				...state.create,
				loading: true,
			},
		}),
		[`${ACTIONS.CREATE}_REJECTED`]: (state, action) => ({
			...state,
			create: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.CREATE}_FULFILLED`]: (state, action) => ({
			...state,
			create: {
				error: null,
				success: action.payload,
				loading: false,
			},
		}),
		[`${ACTIONS.UPDATE}_PENDING`]: (state) => ({
			...state,
			update: {
				...state.update,
				loading: true,
			},
		}),
		[`${ACTIONS.UPDATE}_REJECTED`]: (state, action) => ({
			...state,
			update: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.UPDATE}_FULFILLED`]: (state, action) => ({
			...state,
			update: {
				error: null,
				success: action.payload,
				loading: false,
			},
		}),
		[`${ACTIONS.GET}_PENDING`]: (state) => ({
			...state,
			get: {
				...state.get,
				loading: true,
			},
		}),
		[`${ACTIONS.GET}_REJECTED`]: (state, action) => ({
			...state,
			get: {
				error: action.payload,
				success: null,
				loading: false,
			},
		}),
		[`${ACTIONS.GET}_FULFILLED`]: (state, action) => ({
			...state,
			get: {
				error: null,
				success: action.payload,
				loading: false,
			},
		}),
		[`${ACTIONS.LOAD_FORM}_PENDING`]: (state, action) => ({
			...state,
			currentForm: {
				...state.currentForm,
				loading: true,
			},
		}),
		[`${ACTIONS.LOAD_FORM}_FULFILLED`]: (state, action) => ({
			...state,
			currentForm: {
				loading: false,
				success: action.payload,
				error: null,
			},
		}),
		[`${ACTIONS.LOAD_FORM}_REJECTED`]: (state, action) => ({
			...state,
			currentForm: {
				loading: false,
				success: null,
				error: action.payload,
			},
		}),
		[`${ACTIONS.GET_FORM_RESULT}_PENDING`]: (state, action) => ({
			...state,
			getFormResult: {
				loading: true,
				success: null,
				error: null,
				finished: false,
			},
		}),
		[`${ACTIONS.GET_FORM_RESULT}_FULFILLED`]: (state, action) => ({
			...state,
			getFormResult: {
				loading: false,
				success: action.payload,
				error: null,
				finished: true,
			},
		}),
		[`${ACTIONS.GET_FORM_RESULT}_REJECTED`]: (state, action) => ({
			...state,
			getFormResult: {
				loading: false,
				success: null,
				error: action.payload,
				finished: true,
			},
		}),
		[`${ACTIONS.SUBMIT_FORM_RESULT}_PENDING`]: (state, action) => ({
			...state,
			submitFormResult: {
				loading: true,
				success: null,
				error: null,
			},
		}),
		[`${ACTIONS.SUBMIT_FORM_RESULT}_FULFILLED`]: (state, action) => ({
			...state,
			submitFormResult: {
				loading: false,
				success: action.payload,
				error: null,
			},
		}),
		[`${ACTIONS.SUBMIT_FORM_RESULT}_REJECTED`]: (state, action) => ({
			...state,
			submitFormResult: {
				loading: false,
				success: null,
				error: action.payload,
			},
		}),
		[ACTIONS.RESET]: (state) => ({ ...initialState }),
	},
	initialState
);

export interface CreateSystemState {
	create: any;
	update: any;
	get: any;
	currentForm: any;
	getFormResult: any;
	submitFormResult: any;
}
